import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { AsyncPipe, KeyValue } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { BannerFacade } from '@justonweb/backend-services';
import { startWith, switchMap } from 'rxjs/operators';
import { AppService } from '../../app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BannerModule } from '@justonweb/banner';
import { UpperCasePipe } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@Component({
    selector: 'jow-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
      TranslocoDirective,
      TranslocoPipe,
      BannerModule,
      UpperCasePipe,
      MatChipsModule,
      AsyncPipe
    ]
})
export class HeaderComponent implements OnInit {
  logoLink$ = new BehaviorSubject('assets/imgs/FOD_wit-nl-T.png'); 

  private sitesFr: KeyValue<string, string>[] = [
    { key: 'nsi-sa', value: 'http://nsi-sa.be' },
    { key: 'axi', value: 'http://axi.be' }
  ];
  private sitesNl: KeyValue<string, string>[] = [
    { key: 'nsi-sa nl', value: 'http://nsi-sa.be' },
    { key: 'axi nl', value: 'http://axi.be' }
  ];
  private sitesDe: KeyValue<string, string>[] = [
    { key: 'nsi-sa de', value: 'http://nsi-sa.be' },
    { key: 'axi de', value: 'http://axi.be' }
  ];
  public sites: KeyValue<string, string>[];
  public selectedValue: string;

  bannerMessages$: Observable<string[]>;

  private destroyRef = inject(DestroyRef);

  constructor(
    private appService: AppService,
    public translateService: TranslocoService,
    private bannerFacade: BannerFacade,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    //Check if we have a lang in local storage (will be set in upperCase)
    this.selectedValue = localStorage.getItem('lang');
    this.setLanguage();

    this.appService.lang$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((lang: string) => {
        if (lang !== this.selectedValue) {
          this.selectedValue = lang;
          this.setLanguage();
        }
      });

    this.bannerMessages$ = this.translateService.langChanges$
      .pipe(
        startWith(this.translateService.getActiveLang()),
        switchMap((language: string) => this.bannerFacade.getMessages('REGBP_B1', language))
      );
  }

  private setLanguage(){
    //If not check if we can set by browserLang, if browserlang === NL,FR,DE set to that lang otherwise use fallback lang => NL
    //known browser langs we wish to accept 'FR','FR-BE','FR-CA','FR-FR','FR-LU','FR-MC','FR-CH','NL','NL-BE','NL-NL','DE','DE-DE','DE-AT','DE-LI','DE-LU','DE-CH'
    
    if(!this.selectedValue){
      const browserLang = navigator.language.toUpperCase();

      if(!!browserLang){
        if(browserLang.startsWith('NL')){
          this.selectedValue = 'NL';
        }
        else if(browserLang.startsWith('FR')){
          this.selectedValue = 'FR';
        }
        else if(browserLang.startsWith('DE')){
          this.selectedValue = 'DE';
        }
        else{
          this.selectedValue = 'NL';
        }
      }
      else{
        this.selectedValue = 'NL';
      }
      
    }

    this.translateService.setActiveLang(this.selectedValue.toLowerCase());
    this.setCurrentSites();
  }

  public onLanguageChanged() {
    this.setCurrentSites();
    this.translateService.setActiveLang(this.selectedValue.toLowerCase());
    localStorage.setItem('lang', this.selectedValue);

    this.router.navigate(
      [], 
      {
        relativeTo: this.activatedRoute,
        queryParams: {lang: this.translateService.getActiveLang()}, 
        queryParamsHandling: 'merge'
      }
    );
  }

  private setCurrentSites() {
    switch (this.selectedValue.toUpperCase()) {
      case 'FR':
        this.sites = this.sitesFr;
        this.logoLink$.next("assets/imgs/SPF_wit-FR.svg");
        break;
      case 'NL':
        this.sites = this.sitesNl;
        this.logoLink$.next("assets/imgs/FOD_wit-NL.svg");
        break;
      case 'DE':
        this.sites = this.sitesDe;
        this.logoLink$.next("assets/imgs/FOD_wit-DE.svg");
        break;
    }
  }
}
